// extracted by mini-css-extract-plugin
export var sliderRange = "_qi-2";
export var sliderRoot = "_qi-0";
export var sliderThumb = "_qi-3";
export var sliderTrack = "_qi-1";